import React from 'react';
import { Flex, Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { ManageFieldActionSubjectId } from '../../../../../common/constants/analytics.tsx';

import { useOpenManageFieldTab } from '../../../../../controllers/use-open-manage-field-tab/useOpenManageFieldTab.tsx';

export type ManageFieldButtonProps = {
	url: string;
	label: string;
	source: ManageFieldActionSubjectId;
	isFooterOption?: boolean;
};

export const ManageFieldButton = ({
	url,
	label,
	source,
	isFooterOption,
}: ManageFieldButtonProps) => {
	const openManageFieldTab = useOpenManageFieldTab({
		source,
		url,
	});

	const button = (
		<Pressable
			xcss={isFooterOption ? footerOptionStyles : buttonStyles}
			onClick={openManageFieldTab}
		>
			{label}
		</Pressable>
	);
	return isFooterOption ? <>{button}</> : <Flex xcss={flexContainerStyles}>{button}</Flex>;
};

const buttonStyles = xcss({
	borderRadius: 'border.radius',
	alignItems: 'center',
	textAlign: 'left',
	fontWeight: 'font.weight.medium',
	padding: 'space.150',
	height: '100%',
	width: '100%',
	backgroundColor: 'color.background.neutral.subtle',
	':hover': {
		backgroundColor: 'color.background.input.hovered',
	},
});
const footerOptionStyles = xcss({
	alignItems: 'center',
	textAlign: 'left',
	fontWeight: 'font.weight.medium',
	height: '100%',
	width: '100%',
	backgroundColor: 'color.background.neutral.subtle',
});
const flexContainerStyles = xcss({
	flexGrow: 1,
	height: token('space.500'),
});
